module.exports = __webpack_public_path__ + "static/media/bigPurple.36d1ed04.JPG";